import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListSubheader,
} from "@mui/material";

const QualityRankSelect = ({
  value,
  onChange,
  error = false,
  errorMessage = "",
  maxValue = 0.95, // show up to 1
  step = 0.01, // step for increment
}) => {
  const categories = [
    { label: "Excellent", min: 0.95, max: 1, color: "badge-success" },
    { label: "Very Good", min: 0.85, max: 0.94, color: "badge-success" },
    { label: "Good", min: 0.75, max: 0.84, color: "badge-info" },
    { label: "Fair", min: 0.6, max: 0.74, color: "badge-warning" },
    { label: "Poor", min: 0.4, max: 0.59, color: "badge-danger" },
  ];

  // Flatten into one array for Select
  const items = categories.flatMap((cat) => {
    const numbers = [];
    for (let i = cat.max; i >= cat.min; i = parseFloat((i - step).toFixed(2))) {
      if (i <= maxValue) numbers.push(i);
    }

    if (numbers.length === 0) return [];

    return [
      <ListSubheader key={`header-${cat.label}`}>{cat.label}</ListSubheader>,
      ...numbers.map((num) => (
        <MenuItem key={`${cat.label}-${num}`} value={num}>
          ({num})
          <small className={`ml-1 ${cat.color} px-1 border rounded`}>
            x{num}
          </small>
        </MenuItem>
      )),
    ];
  });

  return (
    <FormControl fullWidth size="small" className="mb-3">
      <InputLabel className={error ? "text-danger" : ""}>
        Rank the quality of reported work
      </InputLabel>

      <Select
        value={value}
        error={error}
        onChange={(e) => onChange(e.target.value)}
        MenuProps={{
          PaperProps: {
            style: { maxHeight: 300 },
          },
        }}
      >
        {items}
      </Select>

      {error && (
        <small className="text-danger ml-2" style={{ fontSize: "12px" }}>
          {errorMessage}
        </small>
      )}
    </FormControl>
  );
};

export default QualityRankSelect;
